import { W47_BASE_ALLOYS, baseGroupForAlloy } from "./w47-aluminum-data";

export type AnnexKGroup = 1 | 2 | 3 | 4 | 5;
export type AnnexKMaterial = {
  alloy: string;
  group: AnnexKGroup;
  tensileBand: string;
};

export const ANNEX_K_TENSILE_BANDS: Record<AnnexKGroup, string> = {
  1: "450–490 MPa",
  2: ">490–520 MPa",
  3: ">520–550 MPa",
  4: ">550–620 MPa",
  5: "660 MPa and over",
};

const group1 = [
  "304","304L","304H","316","316L","316H","321","321H","347","347H",
  "CF-3","CF-3M","CF-8","CF-8C","CF-8M","CF-10","CF-10M","CF-20","CH-20","CG-10",
  "CPF3","CPF3M","CPF8","CPF8C","CPF8M","CPH8","CPH10","CPH20","16 8-2H",
];
const group2 = [
  "201","202","301","302","304","304H","304L","308","309","309Cb","309H","309HCb","309S","309S-Cb",
  "316","316L","316Cb","316H","316Ti","317","317L","321","321H","347","347H","348","348H","16 8-2H","CG-8M",
];
const group3 = ["CF-3A","CF-8A"];
const group4 = ["202","205","XM-10","XM-11","XM-17","XM-18"];
const group5 = ["201","201-1","201-2","205","XM-19","XM-28","XM-29"];

export const ANNEX_K_MATERIALS: AnnexKMaterial[] = [
  ...group1.map(alloy => ({ alloy, group: 1 as const, tensileBand: ANNEX_K_TENSILE_BANDS[1] })),
  ...group2.map(alloy => ({ alloy, group: 2 as const, tensileBand: ANNEX_K_TENSILE_BANDS[2] })),
  ...group3.map(alloy => ({ alloy, group: 3 as const, tensileBand: ANNEX_K_TENSILE_BANDS[3] })),
  ...group4.map(alloy => ({ alloy, group: 4 as const, tensileBand: ANNEX_K_TENSILE_BANDS[4] })),
  ...group5.map(alloy => ({ alloy, group: 5 as const, tensileBand: ANNEX_K_TENSILE_BANDS[5] })),
];

export const ANNEX_K_ALLOYS = Array.from(new Set(ANNEX_K_MATERIALS.map(item => item.alloy)))
  .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));

export const annexKOptionsForAlloy = (alloy: string) =>
  ANNEX_K_MATERIALS.filter(item => item.alloy === alloy);

export const annexKGroupsForAlloy = (alloy: string): AnnexKGroup[] =>
  annexKOptionsForAlloy(alloy).map(item => item.group);

export const annexKGroupForAlloy = (alloy: string, selectedGroup?: number | null): AnnexKGroup | null => {
  const options = annexKOptionsForAlloy(alloy);
  if (selectedGroup && options.some(item => item.group === selectedGroup)) return selectedGroup as AnnexKGroup;
  return options.length === 1 ? options[0].group : null;
};

export const ALUMINUM_ALLOYS = W47_BASE_ALLOYS.map(item => item.alloy);
export const aluminumGroupForAlloy = baseGroupForAlloy;
